module.exports = __webpack_public_path__ + "img/c_flu.627ffb6a.jpg";